import { createSlice } from "@reduxjs/toolkit";
import { getCountries, getJobs, getSectors, getLanguages, getRegions } from "../thunks/constantsThunk";
import { IConstantsState } from "../types/constants";

const initialState: IConstantsState = {
  countries: [],
  jobs: [],
  sectors: [],
  languages: [],
  regions: [],
  loading: {
    countries: false,
    jobs: false,
    sectors: false,
    languages: false,
    regions: false,
  },
  error: {
    countries: null,
    jobs: null,
    sectors: null,
    languages: null,
    regions: null,
  },
};

export const constantsSlice = createSlice({
  name: "constants",
  initialState,
  reducers: {
    clearConstants: (state) => {
      state.countries = [];
      state.jobs = [];
      state.sectors = [];
      state.languages = [];
      state.regions = [];
    },
    clearErrors: (state) => {
      state.error = {
        countries: null,
        jobs: null,
        sectors: null,
        languages: null,
        regions: null,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      // Countries
      .addCase(getCountries.pending, (state) => {
        state.loading.countries = true;
        state.error.countries = null;
      })
      .addCase(getCountries.fulfilled, (state, action) => {
        state.loading.countries = false;
        state.countries = action.payload as any;
      })
      .addCase(getCountries.rejected, (state, action) => {
        state.loading.countries = false;
        state.error.countries = action.payload as string;
      })
      // Jobs
      .addCase(getJobs.pending, (state) => {
        state.loading.jobs = true;
        state.error.jobs = null;
      })
      .addCase(getJobs.fulfilled, (state, action) => {
        state.loading.jobs = false;
        state.jobs = action.payload as any;
      })
      .addCase(getJobs.rejected, (state, action) => {
        state.loading.jobs = false;
        state.error.jobs = action.payload as string;
      })
      // Sectors
      .addCase(getSectors.pending, (state) => {
        state.loading.sectors = true;
        state.error.sectors = null;
      })
      .addCase(getSectors.fulfilled, (state, action) => {
        state.loading.sectors = false;
        state.sectors = action.payload as any;
      })
      .addCase(getSectors.rejected, (state, action) => {
        state.loading.sectors = false;
        state.error.sectors = action.payload as string;
      })
      // Languages
      .addCase(getLanguages.pending, (state) => {
        state.loading.languages = true;
        state.error.languages = null;
      })
      .addCase(getLanguages.fulfilled, (state, action) => {
        state.loading.languages = false;
        state.languages = action.payload as any;
      })
      .addCase(getLanguages.rejected, (state, action) => {
        state.loading.languages = false;
        state.error.languages = action.payload as string;
      })
      // Regions
      .addCase(getRegions.pending, (state) => {
        state.loading.regions = true;
        state.error.regions = null;
      })
      .addCase(getRegions.fulfilled, (state, action) => {
        state.loading.regions = false;
        state.regions = action.payload as any;
      })
      .addCase(getRegions.rejected, (state, action) => {
        state.loading.regions = false;
        state.error.regions = action.payload as string;
      });
  },
});

export const { clearConstants, clearErrors } = constantsSlice.actions;
export default constantsSlice.reducer; 